<template>
    <v-speed-dial v-model="fab" direction="left" class="">
        <template v-slot:activator>
            <v-btn v-model="fab" color="secondary darken-2" dark fab>
                <v-icon v-if="fab"> mdi-close </v-icon>
                <v-icon v-else> mdi-plus </v-icon>
            </v-btn>
        </template>
        <v-tooltip top color="secondary">
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    dark
                    small
                    color="secondary"
                    v-bind="attrs"
                    v-on="on"
                    @click="addProgram"
                >
                    <v-icon>mdi-home-plus</v-icon>
                </v-btn>
            </template>
            Add Program
        </v-tooltip>
    </v-speed-dial>
</template>

<script>
export default {
    name: "program-options-menu",
    data() {
        return {
            fab: false,
        };
    },
    methods: {
        addProgram() {
            this.$router.push({
                name: "Program Edit",
            });
        },
    },
};
</script>

<style lang="scss" scoped>
</style>